import { useGetExercisePresets } from '#api/exercise-presets';
import { useGetExerciseTypes } from '#api/exercise-types';
import { PurplePlus } from '#assets/svg';
import { useDashboardChartFormProcess } from '#pages/DashboardChartForm/hooks/useDashboardChartFormProcess';
import { useDashboardCharFormExerciseState } from '#pages/DashboardChartForm/states/dashboardCharFormExerciseState';
import { ButtonSubmit } from '#pages/WeeklyCalenderScheduleRegistration/styles';
import { useExercisePresetChartRecoil } from '#states/exercisePresetsState';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { PresetItem } from './PresetItem';
import { ChangePresetsBottomSheet } from './change-presets/ChangePresets';
import TagManager from 'react-gtm-module';

export const SelectPresetsPage = () => {
  // bottom sheet
  const [openBottomSheet, setOpenBottomSheet] = useState<boolean>(false);

  // api로 추가해서 등록된 프리셋 리스트
  const { data: exercisePresets } = useGetExercisePresets();

  // 운동차트 작성에 들어갈 프리셋 관리
  const { exercisePresetChart, setExercisePresetChart } =
    useExercisePresetChartRecoil();

  const { records, setRecords } = useDashboardCharFormExerciseState();

  const { data } = useGetExerciseTypes();

  const { setTab } = useDashboardChartFormProcess();

  const onSubmit = () => {
    const presetWorkoutList = exercisePresetChart
      .map(preset => preset.exercisePresetWorkout)
      .flat();

    const exerciseList = presetWorkoutList.map(workout => ({
      exerciseKind:
        data?.data.find(item => item.id === workout.exerciseTypeId)?.name || '',
      exerciseTypeId: workout.exerciseTypeId,
      sets: workout.sets.map(set => ({
        setType: set?.setType,
        round: set?.round,
        weight: set?.weight,
        time: set?.time,
        reps: set?.reps
      }))
    }));

    setRecords(exerciseList);
    TagManager.dataLayer({
      dataLayer: {
        event: 'exercisechart_presetadd_complete',
        category: '회원관리',
        action: 'exercisechart_presetadd_complete',
        value: 2
      }
    });
    setTab('폼');
  };

  useEffect(() => {
    if (records.length === 0) {
      setRecords([
        {
          exerciseKind: '',
          exerciseTypeId: '',
          sets: [
            {
              setType: 'REPWEIGHT',
              round: 1,
              weight: 0,
              reps: 0,
              time: 0
            }
          ],
          images: [],
          videos: []
        }
      ]);
    }
  }, [records]);

  if (!exercisePresets) {
    return <div></div>;
  }

  return (
    <PrevHeaderBarWithTitleTemplate
      onPrevCallback={() => setExercisePresetChart([])}
      title="프리셋"
      rightContents={
        <ButtonSubmit
          disabled={exercisePresetChart.length === 0}
          onClick={onSubmit}
        >
          완료
        </ButtonSubmit>
      }
      defaultBackground
    >
      <div className="p-20">
        <div className="text-[#bcb8c3] text-lg font-medium font-['Pretendard Variable'] leading-snug">
          자주 사용하는 운동 가이드를
          <br />
          프리셋으로 만들어 사용해보세요!
        </div>

        <div className="flex flex-col gap-12 mt-28">
          {exercisePresets?.map((preset, index) => (
            <PresetItem key={preset.id} {...preset} />
          ))}
        </div>

        {exercisePresets?.length === 0 && (
          <div className="mt-28 px-20 py-40 text-center text-[#938f9e] text-[17px] font-medium font-['Pretendard Variable'] leading-snug">
            등록된 프리셋이 없습니다
          </div>
        )}

        <PlusButton
          text="프리셋 추가"
          onClick={() => {
            TagManager.dataLayer({
              dataLayer: {
                event: 'exercisechart_presetadd_click',
                category: '회원관리',
                action: 'exercisechart_presetadd_click',
                value: 2
              }
            });
            setOpenBottomSheet(true);
          }}
        />

        {openBottomSheet && (
          <ChangePresetsBottomSheet
            openBottomSheet={openBottomSheet}
            setOpenBottomSheet={setOpenBottomSheet}
          />
        )}
      </div>
    </PrevHeaderBarWithTitleTemplate>
  );
};

const Plus = styled(PurplePlus)`
  path {
    fill: #bcb8c3;
  }
`;

interface PlusButtonProps {
  text: string;
  onClick: () => void;
  style?: React.CSSProperties;
}
const PlusButton = ({ text, onClick, style }: PlusButtonProps) => {
  return (
    <div
      onClick={onClick}
      className="mt-20 w-full h-[54px] px-10 bg-[#2e2a3a] rounded-lg justify-center items-center gap-4 inline-flex"
      style={style}
    >
      <Plus />
      <div className="text-[#bcb8c3] text-[17px] font-medium font-['Pretendard Variable'] leading-snug">
        {text}
      </div>
    </div>
  );
};
